import React from "react";
import { motion } from "framer-motion";
import { FiPhone, FiMail, FiMapPin, FiClock } from "react-icons/fi";
import "./Footer.css";

const Footer = () => {
  const links = [
    { label: "Home", href: "/" },
    { label: "Products", href: "/properties" },
    { label: "Catalog", href: "/property-details" },
    { label: "Contact", href: "/contact" },
  ];

  const contactItems = [
    { icon: <FiPhone />, text: "088856 56752", href: "tel:08885656752" },
    { icon: <FiMail />, text: "burhaniabron@gmail.com", href: "mailto:burhaniabron@gmail.com" },
    { icon: <FiMapPin />, text: "Rani Gunj 'X' Road, Secunderabad, Telangana 500003" },
    { icon: <FiClock />, text: "Mon–Sat: 10AM – 8PM" },
  ];

  return (
    <footer>
      <div className="animated-bg" />

      {/* Main Grid */}
      <div className="footer-main">
        <div className="container">
          <div className="footer-grid">

            {/* Brand */}
            <div className="footer-brand">
              <h3 className="footer-logo">Trinox</h3>
              <p className="footer-tagline">
                Your trusted partner for premium grinding wheels and precision abrasive solutions.
              </p>
            </div>

            {/* Quick Links */}
            <div className="footer-col">
              <h4 className="footer-heading">Quick Links</h4>
              <ul className="footer-nav">
                {links.map(({ label, href }) => (
                  <li key={label}>
                    <motion.a
                      whileHover={{ x: 5 }}
                      transition={{ type: "spring", stiffness: 300, damping: 20 }}
                      href={href}
                    >
                      {label}
                    </motion.a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div className="footer-col">
              <h4 className="footer-heading">Get In Touch</h4>
              <ul className="footer-contact">
                {contactItems.map(({ icon, text, href }, i) => (
                  <li key={i}>
                    <span className="contact-icon">{icon}</span>
                    {href ? (
                      <a href={href}>{text}</a>
                    ) : (
                      <span>{text}</span>
                    )}
                  </li>
                ))}
              </ul>
            </div>

          </div>
        </div>
      </div>

      <div className="footer-divider" />

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <div className="container">
          <p className="footer-copy">© 2026 Trinox. All Rights Reserved.</p>
          <p className="footer-dev">
            Developed by{" "}
            <motion.a
              whileHover={{ color: "#00bcd4" }}
              href="https://burhanitechsolutions.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Burhani Tech Solutions
            </motion.a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
